export class JobMissingError extends Error {
  constructor() {
    super("No job found to process");
  }
}
